module.exports = __webpack_public_path__ + "static/media/astronaut.05987a47.png";